export default __webpack_public_path__ + "static/media/1022.d78fc98a.svg";